// extracted by mini-css-extract-plugin
export var actions = "_rz-4";
export var item = "_rz-1";
export var price = "_rz-3";
export var quantity = "_rz-2";
export var table = "_rz-0";